import { Component, OnInit, Input, OnDestroy } from '@angular/core';
/**
 * Rxjs Import
 */
import { Subscription } from 'rxjs';
/**
 * Import services
 */
import { GetService } from '../../../dataservices/get.service';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { NewLanguageService } from './../../../dataservices/new-language/new-language.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { PostApiService } from './../../../dataservices/post-api.service';

/**
 * Enum Import
 */
import { userStatus, productType, meetingStatus, meetingType } from './../calendar-events-enum/user-status-enum';
/**
 * Environment Import
 */
import { environment } from './../../../../environments/environment';
/**
 * Import interface.
 */
import { CalenderDot } from '../model/calenderDots.model';
import { MeetingList, RescheduledGetData, RescheduledMeetingData, MeetingActionType } from '../model/calenderList.model';
/**
 * Model Import
 */
import { MeetingDetail, TimeSlot } from './../../../meeting/model/meeting.model';
/**
 * Toaster Import
 */
import { ToastrService } from 'ngx-toastr';
/**
 * Constant Import.
 */
import { ACTION_TYPE, CTA_TYPE, MEETING_END, PRODUCT_TYPE_CONSTANT_NAME, PRODUCT_TYPE_NUMBER_MAPPING,NUMBERS } from '../../../constants/app.constants';
import { ToastrType } from '../../../onboarding/interface/global.model';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss']
})
export class EventListComponent implements OnInit, OnDestroy {
  @Input() callingOn;
  @Input() callingfrom;
  /**
   * Used to load cards by type of the product
   */
  @Input() productType: number;

  /**
   * Months string name array
   */
  public month_name = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];

  public calender_list_data: MeetingList[];
  public eventList = [];
  public color_code: CalenderDot[];
  public month = 8;
  public year = 2019;
  public day = '';
  public api_in_process = false;
  public no_rec_found = '';
  public dt = new Date();
  /**
   * Used to view date list
   */
  public date: number;
  /**
   * Loading list view
   */
  public loadList = false;
  /**
   * Used to load user status
   */
  public userStatus = userStatus;
  /**
   * Used to load type of products
   */
  public productTypes = productType;
  /**
   * Used to load type of meeting online or offline.
   */
  public meetingType = meetingType;
  /**
   * Used to load meeting status
   */
  public meetingStatus = meetingStatus;
  /**
   * Variable used to store a number value of time
   */
  public currentTime: number;
  /**
   * Variable used to store an string value when no data comes
   */
  public noDataText: string;
  /**
   * Variable used to store an string value when no data comes
   */
  public noDataDescText: string;
  /**
   * Variable used to store an string value for image when no data comes
   */
  public noDataImage: string;
  /**
   * Used to subscribe data from store service
   */
  storeDataSubs: Subscription;
  /**
   * Used to subscribe calendar list
   */
  calendarListSubs: Subscription;
  /**
   * Used to subscribe store data calendar event
   */
  dssChangeCalEventSubs: Subscription;
  /**
   * Used to subscribe store data events
   */
  dssChangeCalEventsSubs: Subscription;
  /**
   * Used to subscribe calendar event list
   */
  dssCalEventListSubs: Subscription;
  /**
   * Used to subscribe meeting reschedule get data
   */
  meetingGetRescheduleDataSubs: Subscription;
  /**
   * Used to subscribe meeting accept
   */
  meetingAcceptSubs: Subscription;
  /**
   * Used to store reschedule meeting data
   */
  public rescheduleFormData: RescheduledGetData;
  /**
   * Used to store meeting data
   */
  public meeting: MeetingList;
  /**
   * Variable to store the meeting reschedule data
   */
  public rescheduleMeetingData: RescheduledMeetingData = { meeting: null, rescheduleData: null };
  /**
   * Used to show popups
   */
  public actionModalActive = false;
  /**
   * Used to show type of popup
   */
  public modalType = '';
  /**
   * Store meeting detail data.
   */
  public meetingData: MeetingDetail;
  /**
   * Variable used to store timezone.
   */
  public localTimeZone: string;
  /**
   * Calendar offset.
   */
  public offset = 1;

  /**
   * Variable used to store 0 value when there is no rescheduleId
   */
  public rescheduleId = 0;
  /**
   * Number constants.
   */
  public numbers = NUMBERS;

  /**
   * Instances necessary.
   */
  constructor(
    public mls: NewLanguageService,
    private dss: DataStorageService,
    public fcs: FunCollectionService,
    private getSer: GetService,
    private postSer: PostApiService,
    private analyticSdk: Analytics,
    private toastr: ToastrService) {

    const dt = new Date();
    this.month = (dt.getMonth()) + 1;

    this.dssChangeCalEventSubs = this.dss.onchange_calender_event_data.subscribe(data => {
      this.day = data.day;
      this.month = data.month;
      this.year = data.year;
      this.no_rec_found = '';
    });

    this.dssChangeCalEventsSubs = this.dss.onchange_calender_events_data.subscribe(data => {
      this.date = data.startTime / 1000;
      this.productType = data.productType;
      this.no_rec_found = '';
      this.offset = 1;
      this.calender_list_data = [];
      this.eventList = [];
      this.getCalenderList();
    });

    this.noDataText = this.mls.languageText.calendarEvent_list_NoData.key1;
    this.noDataDescText = this.mls.languageText.calendarEvent_list_NoData.key2;
    this.noDataImage = this.mls.languageText.calendarEvent_list_NoData.key3;
  }

  public canLoad = true;
  public pendingLoad = false;
  public busyGettingData = false;

  ngOnInit(): void {

    setInterval( () => {
      this.canLoad = true;
      if ( this.pendingLoad ) {
        this.onScrollDown();
      }
    }, 2000);

    this.currentTime = this.dt.getTime();
    this.api_in_process = true;
    this.dssCalEventListSubs = this.dss.calendar_event_list.subscribe(data => {
      this.api_in_process = false;
      this.calender_list_data = [];
      this.color_code = [];
      if (data.status === 1) {
        if (data.data.meetingList.length === 0) {
          this.no_rec_found = this.mls.languageText.event_list.key12;
        } else {
          this.no_rec_found = '';
        }
        this.calender_list_data = data.data.meetingList;
        this.color_code = data.data.color_codes;
      }
    });
    /**
     * Added for full calendar page events list
     */
    this.loadList = true;
    this.storeDataSubs = this.dss.calendar_events_list.subscribe(data => {
      this.api_in_process = false;
      this.calender_list_data = [];
      this.color_code = [];
      if (data.status === 1) {
        if (data.data.meetingList.length === 0) {
          this.no_rec_found = this.mls.languageText.event_list.key12;
        } else {
          this.no_rec_found = '';
        }
        this.calender_list_data = data.data.meetingList;
        this.offset = data.data.offset;
        this.date = this.dss.calendarMonthDate;
        this.color_code = data.data.color_codes;
        const calendarEventList = [];
        this.eventList = [];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        data.data.meetingList.forEach(listItem => {
          const dateObj = new Date(listItem.timeSlots[0].startTime);
          const month = dateObj.getMonth();
          const date = dateObj.getDate();
          const year = dateObj.getFullYear();
          const shortDate = date + ' ' + months[month] + ' ' + year;
          const obj = { fullDate: shortDate, date: date, month: months[month], cardData: listItem };
          calendarEventList.push(obj);
        });
        const result = calendarEventList.reduce((r, a) => {
          r[a.fullDate] = r[a.fullDate] || [];
          r[a.fullDate].push(a);
          return r;
        }, Object.create(null));
        // tslint:disable-next-line: forin
        for (const key in result) {
          this.eventList.push({ date: key, card: result[key] });
        }
        this.loadList = false;
      }
    });
    /**
     * Used to store local timeZone text
     */
    this.localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  public onScrollDown():void {
    if(this.busyGettingData){
      return;
    }
    this.busyGettingData = true;
    this.onScroll();
  }

  /**
   * Function used to get calendar list from passing data in api
   */
  getCalenderList(): void {
    this.api_in_process = true;
    this.calender_list_data = [];
    this.color_code = [];
    this.calendarListSubs = this.getSer.getNewCalenderList(this.date, '', this.productType, 1, this.offset).subscribe(resData => {
      this.api_in_process = false;
      this.busyGettingData = false;
      if (resData.status === 1) {
        this.offset = resData.data.offset;
        this.calender_list_data = this.calender_list_data.concat(resData.data.meetingList);
        const calendarEventList = [];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        this.calender_list_data.forEach(listItem => {
          const dateObj = new Date(listItem.timeSlots[0].startTime);
          const month = dateObj.getMonth();
          const date = dateObj.getDate();
          const year = dateObj.getFullYear();
          const shortDate = date + ' ' + months[month] + ' ' + year;
          const obj = { fullDate: shortDate, date: date, month: months[month], cardData: listItem };
          calendarEventList.push(obj);
        });
        const result = calendarEventList.reduce((r, a) => {
          r[a.fullDate] = r[a.fullDate] || [];
          r[a.fullDate].push(a);
          return r;
        }, Object.create(null));
        // tslint:disable-next-line: forin
        for (const key in result) {
          this.eventList.push({ date: key, card: result[key] });
        }
        /**
         * Conditions used to set text when list is empty
         */
        if (this.productType === 0) {
          this.noDataText = this.mls.languageText.calendarEvent_list_NoData.key1;
          this.noDataDescText = this.mls.languageText.calendarEvent_list_NoData.key2;
          this.noDataImage = this.mls.languageText.calendarEvent_list_NoData.key3;
        } else if (this.productType === 41) {
          this.noDataText = this.mls.languageText.calendarEvent_list_NoData.key4;
          this.noDataDescText = this.mls.languageText.calendarEvent_list_NoData.key5;
          this.noDataImage = this.mls.languageText.calendarEvent_list_NoData.key6;
        } else if (this.productType === 7) {
          this.noDataText = this.mls.languageText.calendarEvent_list_NoData.key7;
          this.noDataDescText = this.mls.languageText.calendarEvent_list_NoData.key8;
          this.noDataImage = this.mls.languageText.calendarEvent_list_NoData.key9;
        } else if (this.productType === 27) {
          this.noDataText = this.mls.languageText.calendarEvent_list_NoData.key10;
          this.noDataDescText = this.mls.languageText.calendarEvent_list_NoData.key11;
          this.noDataImage = this.mls.languageText.calendarEvent_list_NoData.key12;
        }
      }
    });
  }

  /**
   * Function used get reschedule meeting data
   */
  getMeetingReschedule(): void {
    this.meetingGetRescheduleDataSubs = this.getSer.getMeetingReschedule().subscribe(data => {
      if (data && data.status === 1 && data.code === 2000) {
        this.rescheduleFormData = data.data;
        this.rescheduleMeetingData.meeting = this.meeting;
        this.rescheduleMeetingData.rescheduleData = this.rescheduleFormData;
      }
    });
  }

  /**
   * Function used send input event from this component
   */
  eventAction(data: MeetingActionType): void {
    if (data.type === 'reschedule') {
      this.getMeetingReschedule();
    }
    this.actionModalActive = data.viewModal;
    this.modalType = data.type;
    this.meeting = data.meeting;
  }

  /**
   * Function used accept meeting when time slot is one
   */
  acceptMeeting(meeting: MeetingList): void {
    let availableSlotId;
    let rescheduleId;
    if (meeting.rescheduleTimeSlots.length === 1) {
      availableSlotId = meeting.rescheduleTimeSlots[0].slotId;
      rescheduleId = meeting.rescheduleTimeSlots[0].slotId;
    } else {
      availableSlotId = meeting.timeSlots[0].slotId;
      rescheduleId = 0;
    }
    const rescheduledMeeting = this.calender_list_data.filter(x => x.productId === meeting.productId)[0];
    this.meetingAcceptSubs = this.postSer.meetingAction(meeting.productId, 'accept', availableSlotId, rescheduleId).subscribe(data => {
      if (data && data.status === 1 && data.code === 2000) {
        rescheduledMeeting.productId = data.data.meetingDetail.meetingId;
        rescheduledMeeting.tags = data.data.meetingDetail.tag;
        rescheduledMeeting.userStatus = data.data.meetingDetail.userStatus;
        rescheduledMeeting.rescheduleTimeSlots = data.data.meetingDetail.rescheduleTimeSlots;
        rescheduledMeeting.timeSlots = data.data.meetingDetail.timeSlots;
        this.fcs.showCustomToast({
          toastType: ToastrType.SUCCESS,
          timeout: 5000,
          message: data.msg,
          title: 'Meeting Accepted By me'
        });

      }
      if (data && data.status === 0 && data.code === 2000) {
        this.fcs.showCustomToast({
          toastType: ToastrType.ERROR,
          timeout: 5000,
          message: data.error.msg,
          title: 'Error Occurred'
        });

      }
    });
  }

  /**
   * Function used to navigate to calendar module
   */
  navigateToCalenderModule(): void {
    this.fcs.navigateToCalenderModule();
  }

  /**
   * Function used to navigate to event detail
   */
  navigateToEventDetail(event): void {
    if (PRODUCT_TYPE_NUMBER_MAPPING[event.productType.toString()])
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_NUMBER_MAPPING[event.productType.toString()], event.productId, this.fcs.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK, PRODUCT_TYPE_NUMBER_MAPPING[event.productType.toString()],null);

    if (event.productType === 27) {
      this.fcs.navigateToWebinarDetail(event.productId);
    } else if (event.productType === 7) {
      this.fcs.navigateToEventDetail(event.productId);
    } else if (event.productType === 41) {
      this.fcs.navigateToMeetingDetail(event.productId);
    }
  }

  /**
   * Function used to cancel selected date
   */
  canceldate(): void {
    this.day = '';
    const x = { day: this.day, month: this.month, year: this.year };
    this.dss.onchange_calender_event_data.next(x);
  }

  /**
   * Function used to open meeting action popups
   */
  actionOnModal(event: boolean): void {
    this.actionModalActive = event;
  }

  /**
   * Update meeting data when any CTA action taken.
   */
  updateMeeting(data): void {
    this.meetingData = data.data.meetingDetail;
    for (const card of this.eventList) {
      card.card.map(data => {
        if (data.cardData.productId === this.meetingData.meetingId) {
          data.cardData = { ...data.cardData };
          data.cardData.tags = this.meetingData.tag;
          data.cardData.userStatus = this.meetingData.userStatus;
          data.cardData.rescheduleTimeSlots = this.meetingData.rescheduleTimeSlots;
        }
      });
    }
  }

  /**
   * Function used to join meeting by redirecting to join meeting page
   */
  joinMeeting(meeting): void {
    const endPointUrl = '/#/speakers/join/';
    /**
     * Key used to store an id number
     */
    let id: number;
    if (meeting.joinMeeting.type === 'doc') {
      id = 2;
    } else {
      id = 1;
    }
    const videoUrl = environment.baseUrls.JOIN_MEETING_URL + endPointUrl
      + meeting.joinMeeting.speakerId + '/'
      + meeting.productType + '/'
      + meeting.joinMeeting.meetingId + '?id='
      + id;
    window.open(videoUrl, '_blank');
  }

  /**
   * Used to convert in desired text for indian timezone
   */
  timeZoneText(text: string): string {
    return text.toLowerCase() === 'asia/calcutta' ? 'Asia/Kolkata' : text;
  }

  /**
   * Call offset on scroll.
   */
  onScroll(): void {
    if (this.offset > 1) {
      this.getCalenderList();
    }
  }

  /**
   * Get Meeting End Date -> End time (11:59:59)
   * @param timeslot - provide timeslot object from meeting detail object
   * @returns meeting day end time.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMeetingDayEndTime(timeslot: TimeSlot): any {
    const meetingDayEndDateTime = new Date(timeslot.endTime).setHours(MEETING_END.hour, MEETING_END.min, MEETING_END.sec);
    return meetingDayEndDateTime;
  }

  /**
   * Used to unsubscribe all subscription
   */
  ngOnDestroy(): void {
    if (this.storeDataSubs) {
      this.storeDataSubs.unsubscribe();
    }
    if (this.calendarListSubs) {
      this.calendarListSubs.unsubscribe();
    }
    if (this.dssChangeCalEventsSubs) {
      this.dssChangeCalEventsSubs.unsubscribe();
    }
    if (this.dssChangeCalEventSubs) {
      this.dssChangeCalEventSubs.unsubscribe();
    }
    if (this.dssCalEventListSubs) {
      this.dssCalEventListSubs.unsubscribe();
    }
    if (this.meetingAcceptSubs) {
      this.meetingAcceptSubs.unsubscribe();
    }
    if (this.meetingGetRescheduleDataSubs) {
      this.meetingGetRescheduleDataSubs.unsubscribe();
    }
  }
}
